import {
    CommunityId,
    EvergreenCommunityListingAvailability,
    ObservationKind,
} from "@sp-crm/core";
import React from "react";
import { useCanRequestCommunityAvailability } from "store/selectors/hooks";
import { CommunityRequestListingUpdatePanel } from "./community-request-listing-update-panel";

interface Props {
    communityId: CommunityId;
    communityName: string;
    availabilityStatus: EvergreenCommunityListingAvailability;
    onDismiss: () => void;
    onSuccess: () => void;
}

export const CommunityRequestAvailabilityUpdatePanel: React.FC<Props> = props => {
    const canRequestAvailability = useCanRequestCommunityAvailability();
    const { communityId, communityName, onDismiss, onSuccess } = props;

    if (!canRequestAvailability) {
        return null;
    }

    const hasAvailability =
        props.availabilityStatus === EvergreenCommunityListingAvailability.Available;

    return (
        <CommunityRequestListingUpdatePanel
            communityId={communityId}
            communityName={communityName}
            onDismiss={onDismiss}
            onSuccess={onSuccess}
            body={`Hi!<br><br>I know you've previously reported that you ${
                hasAvailability ? "have a vacancy" : "do not have a vacancy"
            }, but I wanted to check if that's still the case? You can use the link below to update your availability.<br><br>{{link}}<br><br>Thanks for keeping us in the loop!`}
            subject="Quick update on your availability?"
            observationFocus={ObservationKind.Availability}
        />
    );
};
